export default __webpack_public_path__ + "static/media/accounting-bot.11fa5281.png";